/** Lesson medallion: an 18-petal scalloped disc (the only scalloped shape in the design). */
import { containsHan } from '../core/answer.ts';
import './medallion.css';

export type MedallionState = 'done' | 'current' | 'open' | 'locked';

const PETALS = 18;
const CENTER = 32;
const RADIUS = 26.5;

function scallopPath(): string {
  const step = (Math.PI * 2) / PETALS;
  const chord = 2 * RADIUS * Math.sin(step / 2);
  const arc = (chord / 2) * 1.15;
  const point = (k: number) => {
    const a = k * step - Math.PI / 2;
    return `${(CENTER + RADIUS * Math.cos(a)).toFixed(2)} ${(CENTER + RADIUS * Math.sin(a)).toFixed(2)}`;
  };
  let d = `M${point(0)}`;
  for (let k = 1; k <= PETALS; k += 1) d += ` A${arc.toFixed(2)} ${arc.toFixed(2)} 0 0 1 ${point(k)}`;
  return `${d} Z`;
}

const SCALLOP = scallopPath();

export function Medallion({
  char,
  state,
  size = 56,
}: {
  char: string;
  state: MedallionState;
  size?: number;
}) {
  return (
    <span className={`medallion medallion--${state}`} style={{ width: size, height: size }} aria-hidden="true">
      {state === 'current' && <span className="medallion__pulse" />}
      <svg viewBox="0 0 64 64" width={size} height={size}>
        <path d={SCALLOP} className="medallion__disc" />
        <text
          x="32"
          y="33"
          textAnchor="middle"
          dominantBaseline="central"
          className={containsHan(char) ? 'medallion__char han' : 'medallion__char medallion__char--latin'}
        >
          {char}
        </text>
      </svg>
    </span>
  );
}
